<template>
    <div class="landing-page">
        <div class="landing_header_image">
            <div class="layer"></div>
            <div class="box">
                <div class="title" style="margin-bottom: 2rem;line-height: 2.2rem !important;" data-aos="fade-up" data-aos-delay="100">
                    <strong v-if="selectedLang() == 'en'">Kurdos Healthcare</strong>
                    <strong v-if="selectedLang() == 'ar'"><bdo dir="rtl">كوردوس للرعاية الصحية</bdo></strong>
                    <strong v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەندروستیی کوردۆس</bdo></strong>
                    <strong></strong>
                </div>
                <div class="desc" data-aos="fade-up" data-aos-delay="200">
                    <span v-if="selectedLang() == 'en'">Kurdos Company was established in the year 2007 , Headquartered
                        in Erbil Iraq.
                        Kurdos Company offers comprehensive solutions for the Healthcaro Sector.</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تأسست شركة كردوس عام ٧٠٠٢، ومقرها الرئيسي في
                            أربيل، العراق. تقدم شركة كردوس حلولاً شاملة لقطاع الرعاية الصحية.</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">کۆمپانیای کوردۆس لە ساڵی ٧٠٠٢ دامەزراوە ,
                            بارەگاکەی لە هەولێر عێراقە.
                            کۆمپانیای کوردۆس چارەسەری هەمەلایەنە بۆ کەرتی تەندروستی کارۆ پێشکەش دەکات.</bdo></span>

                </div>
                <button data-aos="fade-up" data-aos-delay="300" @click="gotoAbout">
                    <span v-if="selectedLang() == 'en'" style="text-align: center;">Learn More</span>
                    <span v-if="selectedLang() == 'ar'" style="text-align: center;"><bdo dir="rtl">اقرا
                            مزيد</bdo></span>
                    <span v-if="selectedLang() == 'ku'" style="text-align: center;"><bdo dir="rtl">زیاتر
                            بزانە</bdo></span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"
                        :class="{ 'svgen': selectedLang() == 'en', 'svgk': selectedLang() != 'en' }">
                        <path
                            d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z">
                        </path>
                    </svg>
                </button>
            </div>
        </div>
        <div class="landing-page-body">
            <section class="about-section">
                <div class="about-card">
                    <div class="about-image" data-aos="zoom-out-up">
                        <img src="/images/healthcare2.jpg" alt="">
                    </div>
                    <div class="about-content">
                        <div class="header" data-aos="fade-up" data-aos-delay="100">
                            <span v-if="selectedLang() == 'en'">Who We Are</span>
                            <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">من نحن</bdo></span>
                            <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ئێمە کێین</bdo></span><span
                                :class="{ 'red-line': selectedLang() == 'en', 'red-line-k': selectedLang() != 'en' }"></span>
                        </div>
                        <div class="content" style="font: 16px;">
                            <p data-aos="fade-up" data-aos-delay="200">
                                <span v-if="selectedLang() == 'en'">
                                    Kurdos Company was established in the year 2007 ,
                                    Headquartered in Erbil
                                    Iraq. Kurdos Company offers comprehensive solutions for the Healthcare
                                    Sector.</span>
                                <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تأسست شركة كردوس عام ٧٠٠٢، ومقرها
                                        الرئيسي في أربيل، العراق. تقدم الشركة حلولاً شاملة لقطاع الرعاية
                                        الصحية.</bdo></span>
                                <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">کۆمپانیای کوردۆس لە ساڵی ٧٠٠٢
                                        دامەزرا .
                                        بارەگای سەرەکی لە شاری هەولێرە
                                        عێراق. کۆمپانیای کوردۆس چارەسەری گشتگیر بۆ چاودێری تەندروستی پێشکەش دەکات
                                        کەرت.</bdo></span>

                            </p>
                            <p data-aos="fade-up" data-aos-delay="300">
                                <span v-if="selectedLang() == 'en'">Promoted by a team of Competent Professionals having
                                    more than 25
                                    years of experience in various Healthcare & Logistics verticals , our vision is
                                    to create Kurdos Company into a Trusted Brand that can provide Total
                                    Integrated Solutions to customers in the changing business environment.</span>
                                <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">بفريق من المحترفين الأكفاء الذين
                                        يتمتعون بخبرة تزيد عن ٥٢ عامًا في مختلف قطاعات الرعاية الصحية والخدمات
                                        اللوجستية، تتمثل رؤيتنا في تحويل شركة كردوس إلى علامة تجارية موثوقة قادرة على
                                        تقديم حلول متكاملة شاملة للعملاء في بيئة الأعمال المتغيرة.</bdo></span>
                                <span v-if="selectedLang() == 'ku'"><bdo dir="rtl"
                                    >
                                   
                        لەلایەن تیمێکی پیشەیی لێهاتووەوە کە ئەزموونی
                            زیاتر لە ٥٢ ساڵیان هەیە، بەرەوپێش دەچێت
                            لە بواری جۆراوجۆری چاودێری تەندروستی و لۆجستیدا، دیدگامان دروستکردنی کۆمپانیای کوردۆسە بۆ
                            کۆمپانیایەکی متمانەپێکراو
                            براند
                            کە دەتوانێت چارەسەری یەکگرتووی کۆی گشتی پێشکەش بە کڕیاران بکات لە گۆڕانی ژینگەی بازرگانیدا.إ
                                    </bdo></span>


                            </p>
                        </div>
                        <button data-aos="fade-up" data-aos-delay="400" style="margin-top: 30px;" @click="gotoAbout">
                            <span v-if="selectedLang() == 'en'" style="text-align: center;">Learn More</span>
                            <span v-if="selectedLang() == 'ar'" style="text-align: center;"><bdo dir="rtl">اقرا
                                    مزيد</bdo></span>
                            <span v-if="selectedLang() == 'ku'" style="text-align: center;"><bdo dir="rtl">زیاتر
                                    بزانە</bdo></span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#E43D34"
                                viewBox="0 0 256 256"
                                :class="{ 'svgen': selectedLang() == 'en', 'svgk': selectedLang() != 'en' }">
                                <path
                                    d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z">
                                </path>
                            </svg>
                        </button>
                    </div>

                </div>
            </section>
            <section class="wellness-section">
                <div class="wellness-content">
                    <div class="header" data-aos="fade-up" data-aos-delay="100">
                        <span v-if="selectedLang() == 'en'">Kurdos Wellness</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">صحة</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەندروستی</bdo></span>
                        <span
                            :class="{ 'red-line': selectedLang() == 'en', 'red-line-k': selectedLang() != 'en' }"></span>
                    </div>
                    <div class="content">
                        <p data-aos="fade-up" data-aos-delay="200">
                            <span v-if="selectedLang() == 'en'">
                                Kurdos Wellness offers a wide range <strong>Branded Generic pharmaceutical</strong>
                                products
                                which include
                                parenterals and orals for therapeutic application in Oncology, Cardiovascular, Diabetes,
                                Analgesics & Anti-Inflammatory apart from Anesthesia and Narcotics products.
                            </span>
                            <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">كوردوس ويلنس تقدم مجموعة واسعة من الأدوية
                                    الجنيسة ذات العلامة التجارية،
                                    والتي تشمل أدوية الحقن والتناول الفموي للاستخدام العلاجي في مجالات مثل الأورام،
                                    وأمراض القلب، والسكري، ومسكنات الألم ومضادات الالتهاب، بالإضافة إلى منتجات التخدير
                                    والمخدرات الطبية.</bdo></span>
                            <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">کوردۆس وێڵنێس کۆمەڵێک بەرهەمی دەرمانی
                                    براندەد جێنێریک پێشکەش دەکات کە بریتین لە ئارتێراڵ و زارەکی بۆ بەکارهێنانی چارەسەری
                                    لە ئۆنکۆلۆژی، دڵ و خوێنبەرەکان، شەکرە،
                                    دەرمانی ئازارشکێن و دژە هەوکردن جگە لە بەرهەمەکانی بێهۆشکردن و ماددە هۆشبەرە
                                    تەندروستیەکان.</bdo></span>

                        </p>
                        <button data-aos="fade-left" @click="gotoWellness">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#E43D34"
                                viewBox="0 0 256 256">
                                <path
                                    d="M200,64V168a8,8,0,0,1-16,0V83.31L69.66,197.66a8,8,0,0,1-11.32-11.32L172.69,72H88a8,8,0,0,1,0-16H192A8,8,0,0,1,200,64Z">
                                </path>
                            </svg>
                        </button>
                    </div>
                </div>
                <CardSlider :products="wellness" />
                <div class="devider"></div>
            </section>
            <section class="medtec-section">
                <div class="medtec-content">
                    <div class="header" data-aos="fade-up" data-aos-delay="100">
                        <span v-if="selectedLang() == 'en'">Kurdos MedTech</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">التكنولوجيا الطبية</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەکنەلۆژیای پزیشکی</bdo></span>
                        <span
                            :class="{ 'red-line': selectedLang() == 'en', 'red-line-k': selectedLang() != 'en' }"></span>
                    </div>
                    <div class="content">
                        <p data-aos="fade-up" data-aos-delay="200">
                            <span v-if="selectedLang() == 'en'">Kurdos MedTec focuses on sales & service of Medical
                                Equipment, Devices and Consumables/
                                Disposables for Hospitals and Laboratories. Our product range include Laboratory
                                Equipment &
                                Consumables for <strong> Biochemistry,Cytology,Hematology,Microbiology,Serology &
                                    Transplantation.</strong></span>
                            <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تركز شركة كردوس للتكنولوجيا الطبية على
                                    بيع وصيانة المعدات والأجهزة الطبية والمواد الاستهلاكية للاستخدام مرة واحدة
                                    للمستشفيات والمختبرات. تشمل منتجاتنا معدات ومواد مختبرية لمجالات الكيمياء الحيوية،
                                    وعلم الخلايا، وعلم الدم، وعلم الأحياء الدقيقة، وعلم الأمصال، وزراعة
                                    الأعضاء.</bdo></span>
                            <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەکنەلۆژیای پزیشکی کوردۆس گرنگی بە فرۆشتن
                                    و خزمەتگوزاری ئامێری پزیشکی و ئامێر و کەلوپەلی بەکارهێنراوی یەکجار بەکارهێنراو بۆ
                                    نەخۆشخانە و تاقیگەکان دەدات. بەرهەمەکانمان بریتین لە ئامێری تاقیگە و
                                    ماددە بەکارهێنراوەکان بۆ بایۆکیمیا، خانەزانیی،خوێن، مایکرۆبایۆلۆجی، سیرۆلۆژی و
                                    چاندن.</bdo></span>


                        </p>
                        <button data-aos="fade-left" @click="gotoMedtec">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#E43D34"
                                viewBox="0 0 256 256">
                                <path
                                    d="M200,64V168a8,8,0,0,1-16,0V83.31L69.66,197.66a8,8,0,0,1-11.32-11.32L172.69,72H88a8,8,0,0,1,0-16H192A8,8,0,0,1,200,64Z">
                                </path>
                            </svg>
                        </button>
                    </div>
                </div>
                <CardSlider :products="medtec" />
                <div class="devider"></div>
            </section>
            <InfraSection/>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import CardSlider from '../../components/healthcare/CardSlider.vue';
import { useRouter } from 'vue-router';
import { selectedLang } from '../../utils/selected_lang';
import InfraSection from '../../components/healthcare/InfraSection.vue';
import { isDark } from '../../utils/theme';


const darkmode = ref(false);
onMounted(() => {
    if (isDark()) {
        document.body.classList.add('dark');
        darkmode.value = true
    }
})

const wellness = ref([
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-004.png',
        title: 'Azit hromycin Tablets',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-006.png',
        title: 'Aceclofenac & Paracetamol Tablets',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-010.png',
        title: 'Ibuprofen Oral Suspension',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-012.png',
        title: 'Ciprofloxacin Tablets',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-016.png',
        title: 'Ciprofloxacin Tablets',
    },
    {
        image: '/images/cover-image.png',
        title: 'Kurdos Wellness',
    },
    

])
const medtec = ref([
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-038.png',
        title: 'Patient Monitor',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-040.png',
        title: 'Central Monitoring System',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-042.png',
        title: 'Patient Monitor - II',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-044.png',
        title: 'Defibrillator Monitor ',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-046.png',
        title: 'Patient Monitor',
    },
    {
        image: '/images/cover-image.png',
        title: 'Kurdos Medtech',
    }
])

const router = useRouter()
function gotoAbout() {
    router.push({ name: 'whoweare' })
}
function gotoWellness() {
    router.push({ name: 'wellness' })
}
function gotoMedtec() {
    router.push({ name: 'medtech' })
}
function gotoInfra() {
    router.push({ name: 'infrastructure' })
}

</script>

<style scoped>
* {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
}


.banner-overlay {
    background-color: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(5px);
    padding: 30px;
    text-align: center;
    max-width: 700px;
}

.banner-overlay h1 {
    font-size: 36px;
    margin-bottom: 15px;
}

.banner-overlay p {
    font-size: 18px;
}

.description {
    padding: 40px 20px;
}

.section {
    margin-bottom: 40px;
}

.section h2 {
    font-size: 24px;
    margin-bottom: 10px;
    color: #1a1a1a;
}

.section p {
    line-height: 1.6;
    margin-top: 10px;
}

.slider-section {
    background-color: #f5f5f5;
    text-align: center;
}

.slider-section h2 {
    font-size: 24px;
    margin-bottom: 20px;
}

.card-slider {
    display: flex;
    overflow-x: auto;
    gap: 20px;
    padding: 10px 0;
    scroll-behavior: smooth;
}

.card {
    min-width: 250px;
    height: 150px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 16px;
    color: #555;
}

.card-slider::-webkit-scrollbar {
    display: none;
}

.card-slider {
    -ms-overflow-style: none;
    scrollbar-width: none;
}


.products-flex {
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    margin-bottom: 40px;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    padding: 10px;
}

.product-card {
    background: white;
    border-radius: 20px;
    overflow: hidden;
    min-width: 300px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.product-image {
    position: relative;
    height: 200px;
    overflow: hidden;
}

.product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.product-card:hover .product-image img {
    transform: scale(1.05);
}

.product-content {
    padding: 25px;
}

.product-content h3 {
    font-size: 1.4rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 10px;
}

.section {
    max-width: 600px;
    margin: 20px auto;
    font-family: Arial, sans-serif;
}

.accordion-toggle {
    display: none;
}

.accordion-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f5f5f5;
    padding: 10px 15px;
    font-weight: bold;
    cursor: pointer;
    border: 1px solid #f3f3f3;
    border-radius: 15px;
    transition: background-color 0.3s;
    font-size: 20px;
}



.accordion-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease, padding 0.3s ease;
    padding: 0 15px;
    border-top: none;
    margin-bottom: 10px;
    border-radius: 0 0 6px 6px;
}

.accordion-toggle:checked~.accordion-content {
    max-height: 500px;
    padding: 15px;
}

.devider {
    width: 110%;
    transform: translateX(-5%);
    height: 1px;
    background-color: rgb(232, 232, 232);
    margin: 40px 0 20px 0;
}
.dark .devider {
    background-color: rgb(57, 57, 57);
}
</style>
